import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import FinancingModal from '../../../containers/masters/Financing/FinancingModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import SimpleTreeSelect from '../../commons/simpleForm/SimpleTreeSelect'
import FinancingMoldalUo from '../../../containers/masters/Financing/FinancingMasterModalUoPage'
import FinancingMoldalProduct from '../../../containers/masters/Financing/FinancingMasterModalProductPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class Financing extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchUO: null,
        searchName: null,
        searchDescription: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchFinancingList()
    this.props.actions.getAllFinancingTypeProduct(false)
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchFinancingList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchFinancingList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitChange (searchUO) {
    if (this.state.filter.searchUO !== searchUO) {
      this.setState({ filter: { ...this.state.filter, searchUO } })
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchFinancing () {
    this.props.actions.fetchFinancingList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchUO: '',
        searchName: '',
        searchDescription: ''
      }
    }, () => { this.searchFinancing() })
  }

  render () {
    const {
      t, financingList, pagesCount, financingCount, filter,
      filter: { page },
      combos: { UOTreeCombo },
      actions: { openEditFinancingModal, openAddFinancingModal, fetchFinancingList, deleteFinancing, recoverFinancing, openEditFinancingModalUo, openEditFinancingModalProduct }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'financingMasters' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const editUOTooltip = (<Tooltip id="editUOTooltip">{t(`${tKey}FINANCING_MASTERS.EDIT_ORGANIZED_UNIT`)}</Tooltip>)
    const editProductTooltip = (<Tooltip id="editProductTooltip">{t(`${tKey}FINANCING_MASTERS.EDIT_PRODUCT_TYPE`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchUO || this.state.filter.searchName || this.state.filter.searchDescription)
    return (
      <div id='financingMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button className="_Btn new" onClick={() => openAddFinancingModal()}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <SimpleTreeSelect
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}FINANCING_MASTERS.ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}FINANCING_MASTERS.ORGANIZED_UNIT`)}
                options={UOTreeCombo}
                searchPlaceholder={t(`${tKey}FINANCING_MASTERS.ORGANIZED_UNIT`)}
                value={this.state.filter.searchUO ? this.state.filter.searchUO.toString() : null}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}FINANCING_MASTERS.NAME`)}
                placeholder={t(`${tKey}FINANCING_MASTERS.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchFinancing()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t(`${tKey}RESET_BUTTON`)}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(financingList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}FINANCING_MASTERS.NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th className='actions' >{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {financingList && financingList.map((financing, idx) => {
                      return (
                        <tr key={idx} className={(financing.isDeleted ? 'is-deleted' : '')}>
                          <td>{financing.name}</td>
                          <td>{financing.description}</td>
                          <td className='actions'>
                            {!financing.isDeleted ? (
                              <div>
                                <OverlayTrigger placement="left" overlay={editUOTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openEditFinancingModalUo(financing)}>
                                    <i className="iDocIcon-Organizational-Unit"/>
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={editProductTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openEditFinancingModalProduct(financing)}>
                                    <i className="glyphicon glyphicon-th" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openEditFinancingModal(financing.financingCompanyId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteFinancing(financing.financingCompanyId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            ) : (
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverFinancing(financing.financingCompanyId, { ...filter, ...this.state.filter })}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              }
              {(financingList === null || financingList === undefined || financingList.length === 0) &&
                <p className="no_results" >{t(`${tKey}FINANCING_MASTERS.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={financingCount}
                    onSelectAction={(value) => fetchFinancingList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <FinancingModal/>
        <FinancingMoldalUo />
        <FinancingMoldalProduct/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listFinancing'
})(Financing)
